import type { DrawingToolInstance, TwoPointCoordinates, TimestampToX, PriceToY } from "./types";
import { applyLineStyle, drawHandleCircle } from "./drawHelpers";

const EXTEND = 10000;

export function drawRayLine(
  ctx: CanvasRenderingContext2D,
  coords: TwoPointCoordinates,
  instance: DrawingToolInstance,
  timestampToX: TimestampToX,
  priceToY: PriceToY,
  draggingCoords?: TwoPointCoordinates,
) {
  const { point1, point2 } = draggingCoords ?? coords;
  const x1 = timestampToX(point1.timestamp);
  const y1 = priceToY(point1.price);
  const x2 = timestampToX(point2.timestamp);
  const y2 = priceToY(point2.price);
  const len = Math.hypot(x2 - x1, y2 - y1);
  if (len === 0) return;

  const ux = (x2 - x1) / len;
  const uy = (y2 - y1) / len;

  applyLineStyle(ctx, instance.mainLine.color, instance.mainLine.width, instance.mainLine.opacity);
  ctx.beginPath();
  ctx.moveTo(x1, y1);
  ctx.lineTo(x1 + ux * EXTEND, y1 + uy * EXTEND);
  ctx.stroke();

  drawHandleCircle(ctx, x1, y1, instance.mainLine.color);
  drawHandleCircle(ctx, x2, y2, instance.mainLine.color);
}
